define("shared/components/shared/ui/modal-with-overlay", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @closable={{false}} @inline={{true}} @primaryClass="o--modalBg--inner {{@overlayClass}}" as |modal|>
    <modal.card class="o--modalCard--narrow u--p__b__0">
      <modal.card-header>
        <p class="o--modalHeader__title">
          {{@title}}
        </p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0 u--p__b__lg">
        {{yield}}
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "vO1z4B13",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@inline\",\"@primaryClass\"],[false,true,[29,[\"o--modalBg--inner \",[30,1]]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"o--modalCard--narrow u--p__b__0\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0 u--p__b__lg\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[18,4,null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@overlayClass\",\"modal\",\"@title\",\"&default\"],false,[\"shared/modal\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/modal-with-overlay.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});